import moment from 'moment'
import client from '@stores/apollo'
import gql from 'graphql-tag'
import handleFetchResult from '@utils/handleFetchResult'

export interface ShareSpaceInput {
  spaceIds: string[]
  recipients: string[]
  assignmentPlanId: string
}

export default function shareSpaceToEmployee(input: ShareSpaceInput) {
  return client.gql.mutate({ mutation, variables: { input } }).then((data: any) => data)
}

const mutation = gql`
  mutation _($input: CreateShareSpaceLocationInput!) {
    createShareSpaceLocation(input: $input) {
      status
    }
  }
`
